import Vue from 'vue';
import alert from './alert2.vue';

let MyAlertConstructor = Vue.extend(alert);

let instance;

// MyAlertConstructor.prototype.closeAlert = function () {

//     const el = instance.$el;
//     el.parentNode && el.parentNode.removeChild(el);

//     typeof this.callback === 'function' && this.callback();
// };

const Alert = (options = {}) => {
    // 创建实例并且过滤参数
    instance = new MyAlertConstructor({
        data: { ...options }
    })
    // instance = new MyAlertConstructor();
    // instance.title = options.title;
    // instance.mes = options.mes;
    // instance.callback = options.callback;
    // 挂载实例
    instance.$mount();
    document.body.appendChild(instance.$el);
    
    return instance;
}

export default Alert;